export default __webpack_public_path__ + "assets/google-play-badge.f902960a.png";